module.exports = __webpack_public_path__ + "assets/499f918fb999dc78196d743a6ea32a40.png";